export const AuthFlowMessages = {
    passwordReset: {
        emailSuccessfullySentMessage:
            'An email has been sent to the address associated with your account with instructions to reset your password.',
    },
} as const;
